import { AiDrawer } from '@aigc/components';
import { useOverlayRef } from '@aigc/overlay-hook';
import { Empty, Typography } from 'antd';
import type { ScriptListItemDto } from '../../script/script.dto';
import { TaskType } from '../../task/model';
import { VideoGenerationTaskTable } from '../../video/components/task-table';

export const ScriptDetailDrawer = (props: {
  script: ScriptListItemDto;
  admin?: boolean;
}) => {
  const overlayRef = useOverlayRef();
  const prompt = props.script.data.prompt.trim();

  return (
    <AiDrawer
      title={`查看脚本 - ${props.script.data.product_name || '未命名产品'}`}
      size="75%"
      classNames={{
        body: 'h-full min-h-0 overflow-auto lg:overflow-hidden',
      }}
      onClose={() => overlayRef.close()}
    >
      <div className="flex h-full min-h-0 gap-6">
        <section className="flex min-w-0 flex-1 flex-col">
          <Typography.Title level={5}>脚本内容</Typography.Title>
          <div className="min-h-0 flex-auto overflow-auto rounded-lg border border-gray-200 p-4">
            {prompt ? (
              <div className="whitespace-pre-wrap break-words">{prompt}</div>
            ) : (
              <Empty description="暂无脚本内容"></Empty>
            )}
          </div>
        </section>

        <section className="flex w-[480px] flex-none flex-col">
          <Typography.Title level={5}>关联视频生成任务</Typography.Title>
          <div className="min-h-0 flex-auto overflow-auto">
            <VideoGenerationTaskTable
              admin={props.admin}
              scriptId={props.script.id}
              taskType={[TaskType.视频生成, TaskType.长视频生成]}
            ></VideoGenerationTaskTable>
          </div>
        </section>
      </div>
    </AiDrawer>
  );
};
